'use client'

import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'

import { AHeaderHamburgerBelowCard } from './a-header-hamburger-below-card'
import { AHeaderHamburgerFooter } from './a-header-hamburger-footer'
import { AHeaderHamburgerServices } from './a-header-hamburger-services'

interface AHeaderHamburgerProps {
	isOpen: boolean
	onClose: () => void
}

export const AHeaderHamburger = ({ isOpen, onClose }: AHeaderHamburgerProps) => {
	return (
		<div className={clsx('header-hamburger', isOpen && 'header-hamburger--open')}>
			<div className='header-hamburger__header'>
				<Link href='/' onClick={onClose}>
					<Image
						unoptimized={true}
						src='/assets/images/medante-logo-light.svg'
						alt='Medante'
						width={431}
						height={115}
					/>
				</Link>

				<button
					type='button'
					title='Zavrieť menu'
					name='toggle-menu'
					className='header-hamburger__close'
					onClick={onClose}
				>
					<svg className='sicofill'>
						<use href='/assets/layout/icons.svg#s_cross' />
					</svg>
				</button>
			</div>

			<div className='header-hamburger__scroll'>
				<div className='header-hamburger__inner'>
					<div className='header-hamburger__content header-hamburger__content--main'>
						<AHeaderHamburgerServices onLinkClick={onClose} menuOpen={isOpen} />

						<AHeaderHamburgerBelowCard />

						<AHeaderHamburgerFooter />
					</div>
				</div>
			</div>
		</div>
	)
}
